import { getSettlementList } from '@/api/wenjuan/settlement'

// 获取列表
export function getList(params) {
  this.loading = true
  getSettlementList(params)
    .then(res => {
      if (res.data.code != 0) {
        this.$message.error(res.data.msg)
        this.loading = false
        return
      }
      this.page.total = res.data.data.total
      this.page.currentPage = res.data.data.current
      this.page.pageSize = res.data.data.size
      this.data = res.data.data.records
      this.data.forEach(item => {
        item.totalAmount = Number(item.totalAmount)
          ? (Number(item.totalAmount) / 100).toFixed(2)
          : Number(item.totalAmount).toFixed(2)
        item.realAmount = Number(item.realAmount)
          ? (Number(item.realAmount) / 100).toFixed(2)
          : Number(item.realAmount).toFixed(2)
        item.adjustAmount = Number(item.adjustAmount)
          ? (Number(item.adjustAmount) / 100).toFixed(2)
          : Number(item.adjustAmount).toFixed(2)
      })
      // 如果当前查询页数 没有数据 往前一页查询一次
      if (this.data.length === 0 && this.page.currentPage != 1) {
        this.page.currentPage--
        if (this.page.currentPage > 0) {
          params.current = this.page.currentPage
          getList(params)
        }
      }
      this.loading = false
    })
    .catch(err => {
      this.loading = false
      console.log(err)
      // return err
    })
}

// 结算单列表字段
export const settlementBillListOptions = {
  column: [
    {
      width: 170,
      label: '结算单号',
      value: 'id',
      fixed: true
    },
    {
      width: 90,
      label: '结算单状态',
      value: 'settleStatus'
    },
    {
      width: 120,
      label: '答卷数量',
      value: 'answerNum'
    },
    {
      width: 105,
      label: '结算费用（元）',
      value: 'realAmount'
    },
    {
      width: 80,
      label: '支付方式',
      value: 'payType'
    },
    {
      label: '银行卡号',
      value: 'bankCardNumber'
    },
    {
      label: '开户行信息',
      value: 'bankCardInfo',
      width: 100,
    },
    {
      label: '联系方式',
      value: 'executorPhone',
      width: 100,
    },
    {
      label: '操作',
      value: 'opt',
      width: 200,
      fixed: 'right'
    }
  ]
}

export const publicPage = {
  total: 0,
  currentPage: 1,
  pageSize: 20,
  pageSizes: [10, 20, 30, 50, 100],
  background: true
}
